import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/**
 * getUTCObjectFromLocalDate:
* Ensures the date is standardized to start of the day in UTC, useful for:
* 
* Date-based filtering

* Normalizing date values in APIs

* Avoiding timezone-related bugs 
*/
export const getUTCObjectFromLocalDate = (localDate?: Date | null) => {
  // This ensures you get 00:00:00 UTC on the same calendar day
  // Converts a given localDate to a Date object representing 00:00 UTC of that day.
  // Example: if localDate = '2025-09-18T15:30:00', this will return a Date for '2025-09-18T00:00:00Z' (UTC).
  const utcStartOfDay = localDate
    ? dayjs
      .utc(
        // Format the localDate as 'YYYY-MM-DD' to strip time,
        // e.g., '2025-09-18T15:30:00' becomes '2025-09-18'
        dayjs(localDate).format("YYYY-MM-DD")
      )
      // Convert to native JS Date object at UTC midnight
      .toDate()
    : null; // If no date is provided, return null

  const responseObj = {
    utcStartOfDayIsoString: utcStartOfDay ? utcStartOfDay?.toISOString() : "",
    utcStartOfDay: utcStartOfDay,
  };

  console.log("[Debug Datehelper] Date Selected ", localDate);

  console.log("[Debug DateHelper] responseObject ", responseObj);

  return responseObj;
};

/**
 * Format a date (Date object or ISO string) to a consistent calendar date,
 * ensuring it is interpreted and formatted in UTC to avoid time zone shifts.
 *
 * Why use UTC?
 * -------------
 * - JavaScript Date objects store time in UTC internally, but Day.js formats them in local time by default.
 * - This can cause date shifts (e.g., showing the previous day) for users in time zones behind UTC.
 * - Using dayjs.utc() avoids this by formatting based on UTC, ensuring all users see the same date.
 *
 * @param inputDate - A JavaScript Date object, ISO string, or null/undefined
 * @param format - A Day.js format string (default is 'MM/DD/YYYY')
 * @returns A formatted date string like '10/03/2025' or an empty string if input is invalid
 */
export function formatUTCDate(
  inputDate: Date | string | null | undefined,
  format: string = 'MM/DD/YYYY'
): string {
  // If the input is null or undefined, return empty string to avoid errors
  if (!inputDate) return '';

  // Use dayjs.utc to ensure the input is treated in UTC and formatted consistently
  return dayjs.utc(inputDate).format(format);
}
